import React from 'react';
import { withStyles, Grid,withRouter } from '../../material-ui'; 
import PreviewDoubleItem from './PreviewDoubleItem';

class PreviewTwoItem extends React.Component {

    render() {
        const { classes, data } = this.props;
        return (
            <Grid container justifyContent='center' className={classes.doubleItemRow} direction='row'>
                <Grid container justifyContent='center' className={classes.doubleItemCon1}>
                    {
                        data[0] && <PreviewDoubleItem data={data[0]} /> 
                    }
                </Grid> 
                <Grid container justifyContent='center' className={classes.doubleItemCon2}>
                    {
                        data[1] && <PreviewDoubleItem data={data[1]} />
                    }
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    doubleItemRow: {
        width: '100vw',
        margin: theme.spacing(0, 0, 1, 0),
    },
    doubleItemCon1: {
        maxWidth: '50%',
        padding: theme.spacing(0, 0.5, 0, 1),
    },
    doubleItemCon2: {
        maxWidth: '50%',
        padding: theme.spacing(0, 1, 0, 0.5),
    },
}))(PreviewTwoItem));